import { Component, OnInit } from "@angular/core";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { calendarUtils } from "src/app/calendar/utils/convertDates.utils";
import {
  ICourseSession,
  IGetQrSessionsParams,
} from "src/app/attendanceRecord/interfaces/SessionsInterface";

// interfaces
import { IUser } from "src/app/models/Identity/user";
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import { UsersService } from "src/app/manage-users/services/user-services/users.service";
import { ModalSharedServiceService } from "src/app/shared/modals/modal-service.service";
import { HttpClient } from "@angular/common/http";
import { SessionsService } from "src/app/services/session/sessions.service";

@Component({
  selector: "app-modal-share-qr-filters",
  templateUrl: "./modal-share-qr-filters.component.html",
  styleUrls: ["./modal-share-qr-filters.component.css"],
})
export class ModalShareQrFiltersComponent implements OnInit {
  protected isLoadingTableData: boolean = false;
  protected errorOccurred: boolean = false;
  // Filter Dates
  public startDate: NgbDate | null = null;
  public endDate: NgbDate | null = null;
  // filters
  public textSearch: string = "";
  // pagination
  page: number = 1;
  pageSize: number = 10;
  collectionSize: number = 0;

  public userLogged: IUser | null = null;
  public userList: IUser[] | null = null;
  // data
  public sessionsList: ICourseSession[] = [];

  constructor(
    private sessionsService: SessionsService,
    private authService: AuthenticationService,
    private _authInternal: AuthenticationService,
    private _userService: UsersService,
    private _sharedModalService: ModalSharedServiceService,
    private httpClient: HttpClient
  ) {}

  // getters
  get getEndDateSelected() {
    return this.endDate ? calendarUtils.dateStructToDate(this.endDate) : null;
  }
  get getStartDateSelected() {
    return this.startDate
      ? calendarUtils.dateStructToDate(this.startDate)
      : null;
  }
  get getShowDatesError() {
    const { getStartDateSelected: startDate, getEndDateSelected: endDate } =
      this;

    return (
      (startDate && !endDate) ||
      (endDate && !startDate) ||
      (startDate && endDate && startDate > endDate)
    );
  }

  get getFilterAndPaginationParams(): IGetQrSessionsParams {
    return {
      pageNumber: this.page,
      pageSize: this.pageSize,
      textSearch: this.textSearch,
      startDate: this.getStartDateSelected
        ? calendarUtils.formatDateToYYYYMMDD(this.getStartDateSelected)
        : "",
      endDate: this.getEndDateSelected
        ? calendarUtils.formatDateToYYYYMMDD(this.getEndDateSelected)
        : "",
    };
  }

  ngOnInit(): void {
    const today = new Date();
    this.startDate = new NgbDate(today.getFullYear(), 1, 1);
    this.endDate = new NgbDate(today.getFullYear(), 12, 31);
    this.getQrList();
  }

  onChangeFilterSearch() {
    this.page = 1;
    this.getQrList();
  }

  reloadPage() {
    window.location.reload();
  }

  getQrList() {
    this.isLoadingTableData = true;
    this.sessionsService
      .getQRShared(
        this._authInternal.currentUserValue.id,
        this.getFilterAndPaginationParams
      )
      .subscribe({
        next: ({ data, pagination }) => {
          this.sessionsList = data;
          this.collectionSize = pagination
            ? pagination?.totalRegistro
            : data.length;
          this.isLoadingTableData = false;
        },
        error: () => {
          this.errorOccurred = true;
          this.sessionsList = [];
          this.isLoadingTableData = false;
          this.collectionSize = 0;
        },
      });
  }
}
